import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[footer-bg-color]' // Attribute selector
})
export class FooterBgColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let background_color = '#ffffff';
    if (localStorage.getItem('footer_background_color') && localStorage.getItem('footer_background_color') != '') {
      background_color = localStorage.getItem('footer_background_color');
    }
    
    this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', background_color);
  }
}


// WEBPACK FOOTER //
// ./src/directives/footer-bg-color/footer-bg-color.ts